<!--

Changes done by 
-> Ajay Vijay Malekar

-->
<!-- actual form  -->
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <h2 id="headings" class="main-headings">Encrypted Visibility Engine Process Analysis</h2>
            <!-- <p>To submit a new request you must be logged into your Cisco account.</p> -->
        </div>
    </div>
</div>

<form class="container-fluid" [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
  <div class="small-container-white">   
    <div class="row">
        <div class="col-md-4 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label class="label">Customer Contact</label>
                    <input id="sample1" type="text" class="input" formControlName="userName" name="userName"
                        placeholder="ex. Customer Name" readonly
                        [ngClass]="{ 'input--state-danger': submitted && f.userName.errors }">
                    <div *ngIf="submitted && f.userName.errors" class="invalid-feedback">
                        <div *ngIf="f.userName.errors.required">User Name is required</div>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-md-4 col-sm-12">
            <div class="form-group__text">
                <label class="label">Customer Email</label>
                <input type="text" class="input" formControlName="userEmail" name="userEmail"
                    placeholder="ex: someome@cisco.com" readonly
                    [ngClass]="{ 'input--state-danger': submitted && f.userEmail.errors }">
                <div *ngIf="submitted && f.userEmail.errors" class="invalid-feedback">
                    <div *ngIf="f.userEmail.errors.required">User Email is required</div>
                </div>
            </div>
        </div>

        <div class="col-md-4 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample2" class="label">Customer Name</label>
                    <input id="sample2" type="text" class="input" formControlName="customerName" name="customerName"
                        placeholder="Customer Name">
                </div>
            </div>
        </div>
    </div>
    </div>

    <div _ngcontent-ctj-c91="" class="row" style="margin-top: 25px;"></div>

 <div class="small-container-white">   
    <div class="row">
        <div class="col-md-12">
            <h2 id="headings" class="sub-main-headings">Encrypted Visibility Details
                <div class="tooltip tooltip--top" style="opacity: 1;" (click)="openUrl()">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75ZM0.25 7C0.25 3.27208 3.27208 0.25 7 0.25C10.7279 0.25 13.75 3.27208 13.75 7C13.75 10.7279 10.7279 13.75 7 13.75C3.27208 13.75 0.25 10.7279 0.25 7Z" fill="#7E868F"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.74997 6.5C5.74997 6.08579 6.08576 5.75 6.49997 5.75H6.99997C7.41419 5.75 7.74997 6.08579 7.74997 6.5V9.29268C8.04127 9.39564 8.24997 9.67344 8.24997 10C8.24997 10.4142 7.91419 10.75 7.49997 10.75H6.99997C6.58576 10.75 6.24997 10.4142 6.24997 10V7.20732C5.95867 7.10437 5.74997 6.82655 5.74997 6.5Z" fill="#7E868F"/>
                        <path d="M6.99991 5C7.55219 5 7.99991 4.55228 7.99991 4C7.99991 3.44772 7.55219 3 6.99991 3C6.44762 3 5.99991 3.44772 5.99991 4C5.99991 4.55228 6.44762 5 6.99991 5Z" fill="#7E868F"/>
                        </svg>
                <div class="tooltip__text_dates_info">
                Click to find out more about the Encrypted Visibility Engine
                </div>
            </div>
            </h2>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="form-group">

                <div class="form-group__text">
                    <label for="sample3" class="label">Fingerprint</label>
                    <input id="sample3" type="text" class="input" formControlName="str_repr" name="str_repr"
                        placeholder="" [ngClass]="{ 'input--state-danger': submitted && f.str_repr.errors }"
                        (keydown.enter)="onSubmit()" >
                    <!--  <div class="help-block">
                        <span class="help-block__text">web application, VPN, word processor</span>
                    </div> -->
                    <div *ngIf="submitted && f.str_repr.errors" class="invalid-feedback">
                        <div *ngIf="f.str_repr.errors.required">Finger Print ID is required</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-3 col-sm-12">
            <div class="form-group">
        
                <div class="form-group__text">
                    <label for="sample3" class="label">VDB Version</label>
                     <input id="sample3" type="text" class="input" formControlName="vdb_version" name="vdb_version"
                    placeholder="latest" [ngClass]="{ 'input--state-danger': submitted && f.vdb_version.errors }"
                    (keydown.enter)="onSubmit()">
                 <div *ngIf="submitted && f.vdb_version.errors" class="invalid-feedback">
                    <div *ngIf="f.vdb_version.errors.required">VDB version is required</div>
                 </div>
                </div>
             </div>
        </div>

        <div class="col-md-3 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample3" class="label">Server Name</label>
                    <input id="sample3" type="text" class="input" formControlName="server_name" name="server_name"
                        placeholder="example.com" (keydown.enter)="onSubmit()" >

                </div>
            </div>
        </div>     

     </div> 


     <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample3" class="label">Application Debug Log(Optional)
                   <div class="tooltip tooltip--top" style="opacity: 1; padding: 0;padding-left: 7px;" >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75ZM0.25 7C0.25 3.27208 3.27208 0.25 7 0.25C10.7279 0.25 13.75 3.27208 13.75 7C13.75 10.7279 10.7279 13.75 7 13.75C3.27208 13.75 0.25 10.7279 0.25 7Z" fill="#7E868F"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.74997 6.5C5.74997 6.08579 6.08576 5.75 6.49997 5.75H6.99997C7.41419 5.75 7.74997 6.08579 7.74997 6.5V9.29268C8.04127 9.39564 8.24997 9.67344 8.24997 10C8.24997 10.4142 7.91419 10.75 7.49997 10.75H6.99997C6.58576 10.75 6.24997 10.4142 6.24997 10V7.20732C5.95867 7.10437 5.74997 6.82655 5.74997 6.5Z" fill="#7E868F"/>
                            <path d="M6.99991 5C7.55219 5 7.99991 4.55228 7.99991 4C7.99991 3.44772 7.55219 3 6.99991 3C6.44762 3 5.99991 3.44772 5.99991 4C5.99991 4.55228 6.44762 5 6.99991 5Z" fill="#7E868F"/>
                            </svg>
                        <div class="tooltip__text_debuglog_info">
                            <div style="max-width:750px;line-height:22px;">
                              <p>To allow troubleshooting on EVE, we have created a manual way to parse the fields based on the application debug logs from the FTD platforms, on top of the new integrated capabilities that will be coming with the 7.4+ releases.</p>
                              <p>In order to get the information we need for the Encrypted Visibility Engine troubleshooting, do the following steps:</p>
                              <li>On the FTD CLI run the command:</li>
                                <div style="font-family:Courier;font-size:13">
                                    >&nbsp;ssh admin@ftd-platform<br>
                                    >&nbsp;system support application-identification-debug<br>
                                </div> 
                              <li>Add additional filtering for your traffic you're monitoring.</li>   
                              <li>Look for the CLI output where it provides the fingerprint string as the example below:</li>
                                <div style="font-family:Courier;font-size:13">
                                192.168.1.177 56470 -> 52.107.251.12 443 6 AS=5 ID=1 <font color=red>process:</font> microsoft office, process_score: 0.885965, threat: false, threat_score: 0.000000, server name: cisco-my.sharepoint.com, fingerprint_status: labeled, <font color='red'>fingerprint:</font> tls/1/(0303)(0a0a130113021303c02cc02bcca9c030c02fcca8c00ac009c014c013009d009c0035002fc008c012000a)[(0000)(000500050100000000)(000a000c000a0a0a001d001700180019)(000b00020100)(000d0018001604030804040105030203080508050501080606010201)(0010000e000c02683208687474702f312e31)(0012)(0015)(0017)(001b0003020001)(002b000b0a0a0a0304030303020301)(002d00020101)(0033)(0a0a)(0a0a)(ff01)] 
                                </div>
                                <li>Copy the whole line and paste it in the Application Debug Log field.</li>
                                <li>After this information is filled in, we will parse and autocomplete this information for the rest of the fields.</li>
                                <li>Press "View Request" to see the results and then Submit your feedback.</li>    
                            </div>  
                        </div>
                     </div> 
                 </label>
                    <input id="sample3" type="text" class="input" placeholder="" (change)="parseApplicationLog()"
                        formControlName="applicationLog" >
                </div>
            </div>   
         </div>

        <div class="col-md-3 col-sm-12">
        <div class="form-group">
            <div class="form-group__text ipAddressPadding">
                <label for="sample3" class="label">IP Address</label>
                <input id="sample3" type="text" class="input" formControlName="ip_address" name="ip_address"
                    placeholder="None" (keydown.enter)="onSubmit()" >

            </div>
        </div>
        </div>

        <div class="col-md-3 col-sm-12">
            <div class="form-group__text">
                <label for="sample3" class="label">Port</label>
                <input id="sample3" type="text" class="input" formControlName="port" name="port" placeholder="443"
                    [ngClass]="{ 'input--state-danger': submitted && f.port.errors }" (keydown.enter)="onSubmit()">
                <div *ngIf="submitted && f.port.errors" class="invalid-feedback">
                    <div *ngIf="f.port.errors.required">Port is required</div>
                </div>
            </div>
            </div>

     </div>       

<!--
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="form-group">

                <div class="form-group__text">
                    <label for="sample3" class="label">Fingerprint</label>
                    <input id="sample3" type="text" class="input" formControlName="str_repr" name="str_repr"
                        placeholder="" [ngClass]="{ 'input--state-danger': submitted && f.str_repr.errors }"
                        (keydown.enter)="onSubmit()">
                 -->   <!--  <div class="help-block">
                        <span class="help-block__text">web application, VPN, word processor</span>
                    </div> -->
                    <!--
                    <div *ngIf="submitted && f.str_repr.errors" class="invalid-feedback">
                        <div *ngIf="f.str_repr.errors.required">Finger Print ID is required</div>
                    </div>
                </div>
            
                <div class="form-group__text">
                    <label for="sample3" class="label">Application Debug Log(Optional)</label>
                    <input id="sample3" type="text" class="input" placeholder="" (change)="parseApplicationLog()"
                        formControlName="applicationLog">
                </div>



            </div>
        </div>

        <div class="col-md-3 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample3" class="label">Server Name</label>
                    <input id="sample3" type="text" class="input" formControlName="server_name" name="server_name"
                        placeholder="cisco-my.sharepoint.com" (keydown.enter)="onSubmit()">

                </div>

            </div>
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample3" class="label">IP Address</label>
                    <input id="sample3" type="text" class="input" formControlName="ip_address" name="ip_address"
                        placeholder="None" (keydown.enter)="onSubmit()">

                </div>
            </div>

        </div>
        <div class="col-md-2 col-sm-12">
            <div class="form-group__text">
                <label for="sample3" class="label">VDB Version</label>
                <input id="sample3" type="text" class="input" formControlName="vdb_version" name="vdb_version"
                    placeholder="latest" [ngClass]="{ 'input--state-danger': submitted && f.vdb_version.errors }"
                    (keydown.enter)="onSubmit()">
                <div *ngIf="submitted && f.vdb_version.errors" class="invalid-feedback">
                    <div *ngIf="f.vdb_version.errors.required">VDB version is required</div>
                </div>
            </div>
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample3" class="label">Port</label>
                    <input id="sample3" type="text" class="input" formControlName="port" name="port" placeholder="443"
                        [ngClass]="{ 'input--state-danger': submitted && f.port.errors }" (keydown.enter)="onSubmit()">
                    <div *ngIf="submitted && f.port.errors" class="invalid-feedback">
                        <div *ngIf="f.port.errors.required">Port is required</div>
                    </div>
                </div>

            </div>
        </div>


</div> 

    <!-- <div class="row">
        <div class="col-md-12">
            <div class="divider"></div>
        </div>
    </div> -->

    <div class="row ">
            <div class="col-2" style="margin-right: -50px;"> 
              <button class="btn btn--primary" type="submit">View Request</button>
              <div  class=" tooltip tooltip--top"
                style="margin-left: 7px; top: 0px; opacity: 1;" (click)="copyToClipboard()">
                <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5172 3.34767C15.2305 2.64484 16.1976 2.25 17.206 2.25C18.2147 2.25 19.1821 2.64509 19.8954 3.34835C20.6087 4.05161 21.0094 5.00544 21.0094 6C21.0094 6.99456 20.6087 7.94839 19.8954 8.65165L19.8798 8.66677L10.7701 17.3102C10.3161 17.741 9.59373 17.7273 9.15676 17.2796C8.7198 16.8319 8.73367 16.1198 9.18773 15.6889L18.2884 7.05404C18.5696 6.77338 18.7274 6.39471 18.7274 6C18.7274 5.60218 18.5671 5.22065 18.2818 4.93934C17.9964 4.65804 17.6095 4.5 17.206 4.5C16.8025 4.5 16.4155 4.65804 16.1302 4.93934L6.79832 14.1135C6.79813 14.1137 6.79794 14.1139 6.79776 14.1141C6.15616 14.747 5.79572 15.6052 5.79572 16.5C5.79572 17.3951 6.15637 18.2536 6.79832 18.8865C7.44027 19.5194 8.31094 19.875 9.2188 19.875C10.1267 19.875 10.9973 19.5194 11.6393 18.8865L19.4419 11.2035C19.8877 10.7645 20.6102 10.7649 21.0555 11.2046C21.5008 11.6442 21.5003 12.3565 21.0545 12.7956L13.2529 20.4775C13.2528 20.4776 13.2531 20.4773 13.2529 20.4775C12.1831 21.532 10.7316 22.125 9.2188 22.125C7.70571 22.125 6.25459 21.5324 5.18467 20.4775C4.11475 19.4226 3.51367 17.9918 3.51367 16.5C3.51367 15.0082 4.11475 13.5774 5.18467 12.5225L14.5166 3.34835C14.5168 3.34812 14.517 3.3479 14.5172 3.34767Z" fill="#7E868F"/>
                    </svg>
                <div id="linkClicked" [ngClass]="getLinkcopiedCss()">{{linkedHoverCopiedText}}</div>
              </div>
             </div>  
           <!-- <span *ngIf="applicationList.length>0" style="padding: 5px;">To provide feedback about specific 
            processes, select the applicable entries from the list and submit your request.</span>
            -->
            <div class="col-7">
            <span  >To provide feedback about any of the processes from the list below, select the applicable
                <br>entries and submit your request. If there are no results you can still submit your request.</span>
          </div>        
    </div>
   </div> 
</form>

<div _ngcontent-ctj-c91="" class="row" style="margin-top: 25px;"></div>

<div class="small-container-white">   
<div class="container-fluid mainCADBody">
    <div class="row appDetTable " >
        <div class="col-12 CADSmallTableContainer CADSmallTableContainerPadding">
            <div class="CADSmallTable CADTableFull">
                <div class="table__header-row CADSmallTableHeader">

                    <div class="table__header-cell"><span class="icon-condensed-spacing"></span></div>
                    <div class="table__header-cell" [ngClass]="getSortingClass('process_name')"
                        (click)="sortData('process_name',true)">Process Name</div>
                    <div class="table__header-cell" [ngClass]="getSortingClass('prevalance')"
                        (click)="sortData('preference',true)">Prevalence</div>
                    <div class="table__header-cell" [ngClass]="getSortingClass('server_name')"
                        (click)="sortData('server_name',true)">Server Name</div>
                    <div class="table__header-cell" [ngClass]="getSortingClass('ip_address')"
                        (click)="sortData('ip_address',true)">IP Address</div>
                    <div class="table__header-cell" [ngClass]="getSortingClass('port')" (click)="sortData('port',true)">
                        Port</div>
                </div>
                <div>
             </div>
                <div class="scrollbar scrollbar--direction-vertical CADSmallTableBody">
                     
                    <div *ngIf="applicationList.length==0" class="table__row CADSmallTableRow no-records-bg">
                        <div class="table__cell"></div>
                        <div class="table__cell"></div>
                        <div class="table__cell">
                            <svg width="300" height="120" viewBox="0 0 92 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect opacity="0.4" width="9.64641" height="42.7116" rx="4.8232" transform="matrix(0.907253 -0.420585 -0.424657 -0.905354 24.9766 50.9333)" fill="#A6C4F5"/>
                                <rect opacity="0.2" width="9.64641" height="32.0337" rx="4.8232" transform="matrix(0.907253 -0.420585 -0.424657 -0.905354 22.5879 78.9333)" fill="#A6C4F5"/>
                                <rect opacity="0.3" width="9.64642" height="17.1525" rx="4.82321" transform="matrix(0.907253 -0.420585 -0.424657 -0.905354 73.4023 37.3333)" fill="#A6C4F5"/>
                                <path d="M23.3809 45.4222C23.3809 53.0806 29.6257 59.2889 37.3291 59.2889H53.602C61.3054 59.2889 67.5503 53.0806 67.5503 45.4222V29.2445C67.5503 21.5861 61.3054 15.3778 53.602 15.3778H37.3291C29.6257 15.3778 23.3809 21.5861 23.3809 29.2445V45.4222Z" fill="#5B92F0"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M43.1398 27.5111L43.1398 37.3334C43.1398 38.6098 44.1806 39.6445 45.4645 39.6445C46.7484 39.6445 47.7892 38.6098 47.7892 37.3334L47.7892 27.5111C47.7892 26.2347 46.7484 25.2 45.4645 25.2C44.1806 25.2 43.1398 26.2347 43.1398 27.5111Z" fill="white"/>
                                <path d="M48.3704 46C48.3704 44.4045 47.0693 43.1111 45.4645 43.1111C43.8596 43.1111 42.5586 44.4045 42.5586 46C42.5586 47.5955 43.8596 48.8889 45.4645 48.8889C47.0693 48.8889 48.3704 47.5955 48.3704 46Z" fill="white"/>
                                </svg>
                            <div class="no-records">No records to display.</div>
                        </div>
                        <div class="table__cell"></div>
                        <div class="table__cell"></div>
                        <div class="table__cell"></div>
                    </div>

                    <div *ngFor="let app of applicationList; let index=index">
                        <div class="table__row CADSmallTableRow" id="{{index}}">
                            <div class="table__cell">
                                <label class="checkbox">
                                    <input type="checkbox" class="checkbox__input" id="{{app.process_name}}"
                                        name="{{app.process_name}}"
                                        (change)="getSelectedProcess(index,app.process_name,$event)">
                                    <div class="checkbox__box"></div>
                                    <div class="checkbox__label">Selected</div>
                                </label>
                            </div>
                           <!-- <div class="table__cell" *ngIf="app.isMalware===true"><span
                                    [ngClass]=" color: red">{{app.process_name}}</span>
                            </div>-->
                            <div class="table__cell" *ngIf="app.isMalware===true">
                                <a  style="color: red; " (click)="copyExternalLink(app.process_name)" class="malawaretrue">{{app.process_name}} </a>
                            </div>
                            
                            <div class="table__cell" *ngIf="app.isMalware!=true"><span
                                [ngClass]="app.processNameColor===true ? 'showColor'  : 'showColorNone'">{{app.process_name}}</span>
                          </div>
                            <div class="table__cell"><span class="resultRowPaddingpPevalance"
                                    [ngClass]="app.prevalanceColor===true ? 'showColor'  : 'showColorNone'">{{app.prevalance}}</span>
                            </div>
                            <div class="table__cell"><span class="resultRowPaddingServerName"
                                    [ngClass]="app.serverNameColor===true ? 'showColor'  : 'showColorNone'">{{app.server_name}}</span>
                            </div>
                            <div class="table__cell"><span class="resultRowPaddingIP"
                                    [ngClass]="app.ipAddressColor===true ? 'showColor'  : 'showColorNone'">{{app.ip_address}}</span>
                            </div>
                            <div class="table__cell"><span class="resultRowPaddingPort"
                                    [ngClass]="app.portColor===true ? 'showColor'  : 'showColorNone'">{{app.port}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="padding-left: 300px; padding-top: 20px;">
                <div class="col-md-2 col-sm-12"></div>
                <div class="col-md-2 col-sm-12"></div>
                <div class="col-md-2 col-sm-12"></div>
                <div class="col-md-2 col-sm-12"></div>
                <div class="col-md-2 col-sm-12"></div>
                <div class="col-md-2 col-sm-12">
                <!--   <button class="btn btn--primary" (click)="submitRequest()" *ngIf="applicationList.length>0"
                        [disabled]="isSubmitReqBtnDisabled">Submit Request</button>--> 
                        <button class="btn btn--primary" (click)="submitRequest()" *ngIf="applicationList.length>0"
                            [disabled]="isSubmitReqBtnDisabled" >Submit Request</button>
                </div>
            </div>
        </div>
    </div>

</div>
</div>

<footer class="footer" style="padding-right: 16px;">
    <div class="footer__legal">
        <div class="row">
            <div class="col-md-2">
                @ 2023 Cisco Systems, Inc.
            </div>
            <div class="col-md-7">

            </div>
            <div class="col-md-3">
                <a href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html" style="
                font-weight: 700;color: #1D69CC;">Privacy policy</a>
            
                <a href="https://www.cisco.com/c/en/us/about/legal/terms-conditions.html" style="padding-left: 18px;
                font-weight: 700;color: #1D69CC;">Terms of service</a>
            </div>    
        </div>
    </div>
</footer>
<div id="feedback" class="modal modal--size-small">
    <div class="modal__dialog centerfeedback">
        <div class="modal__content">
            <div class="modal__header">
                <div class="modal__title">Feedback Confirmation</div>
                <a class="modal__close" (click)="closeModal('feedback')"><span class="icon-close"></span></a>
            </div>
            <div class="modal__body">
                <p *ngIf=isChecked>You have selected following process </p>
                <div *ngFor="let app of processNameArr;">
                    <li>{{app}}</li>
                </div>
                <p>Would you like to submit any feedback before submitting request?</p>
                <p>

                    <textarea style="width: 100%;" rows="3" class="textarea" placeholder="Please add some more information about the actual traffic being used versus what we have identified for this type of traffic." [(ngModel)]="feedBackDetails"></textarea>

                </p>
            </div>
            <div class="modal__footer">
                <button class="btn btn--tertiary" (click)="closeModal('feedback')">Cancel</button>
                <button class="btn btn--primary" (click)="submitWithFeedBack()">Submit</button>
            </div>
        </div>
    </div>
</div>